var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-button",style:({
    background: ("" + (_vm.active ? _vm.color : '')),
  })},[_c('div',{staticClass:"circle",style:({
      background: ("" + (_vm.active ? _vm.background : _vm.color)),
      'border-radius': (_vm.circleSize + "px"),
      width: (_vm.circleSize + "px"),
      height: (_vm.circleSize + "px"),
    })}),_c('p',{staticClass:"text",style:({
      color: ("" + (_vm.active ? 'white' : 'black')),
    })},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }